const IMAGE_SIGNATURES: number[][] = [
  [0xff, 0xd8, 0xff], // JPEG
  [0x89, 0x50, 0x4e, 0x47], // PNG
  [0x47, 0x49, 0x46, 0x38], // GIF
  [0x42, 0x4d], // BMP
];

const PDF_SIGNATURE = [0x25, 0x50, 0x44, 0x46]; // %PDF

async function readFileBytes(file: File, count: number): Promise<Uint8Array> {
  const buffer = await file.slice(0, count).arrayBuffer();
  return new Uint8Array(buffer);
}

export async function isImageFile(file: File): Promise<boolean> {
  const bytes = await readFileBytes(file, 12);
  for (const sig of IMAGE_SIGNATURES) {
    if (sig.every((b, i) => bytes[i] === b)) return true;
  }
  // WebP: RIFF????WEBP
  const isWebP =
    bytes[0] === 0x52 &&
    bytes[1] === 0x49 &&
    bytes[2] === 0x46 &&
    bytes[3] === 0x46 &&
    bytes[8] === 0x57 &&
    bytes[9] === 0x45 &&
    bytes[10] === 0x42 &&
    bytes[11] === 0x50;
  return isWebP;
}

export async function isPdfFile(file: File): Promise<boolean> {
  const bytes = await readFileBytes(file, 4);
  return PDF_SIGNATURE.every((b, i) => bytes[i] === b);
}

/**
 * Matches a File against a native `accept` attribute string (e.g. `.csv,text/csv,image/*`).
 * Mirrors the browser's own file-picker filtering so dropped files can be validated the same way.
 */
export function isFileTypeAccepted(file: File, accept?: string): boolean {
  if (!accept) return true;

  const patterns = accept
    .split(',')
    .map((pattern) => pattern.trim().toLowerCase())
    .filter(Boolean);

  if (patterns.length === 0) return true;

  const fileName = file.name.toLowerCase();
  const mimeType = file.type.toLowerCase();

  return patterns.some((pattern) => {
    if (pattern.startsWith('.')) return fileName.endsWith(pattern);
    if (pattern.endsWith('/*')) return mimeType.startsWith(pattern.slice(0, -1));
    return mimeType === pattern;
  });
}
